import xmlDomUtils from '../qti/utils/XmlDomUtils';

const mouseTarget = function mouseTarget(evt = window.event) {
    let targ = evt.target || evt.srcElement;
    if (targ?.nodeType === 3) {
        targ = targ.parentNode; // defeat Safari bug
    }
    return targ;
};

// Mouse position relative to the document
// From http://www.quirksmode.org/js/events_properties.html
const mousePositionDocument = function mousePositionDocument(evt = window.event) {
    let posX = 0;
    let posY = 0;

    if (evt.pageX || evt.pageY) {
        posX = evt.pageX;
        posY = evt.pageY;
    } else if (evt.clientX || evt.clientY) {
        posX = evt.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        posY = evt.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }

    return {
        x: posX,
        y: posY,
    };
};

// Find out where an element is on the page
// From http://www.quirksmode.org/js/findpos.html
const findPos = function findPos(obj) {
    let curleft = 0;
    let curtop = 0;
    let iteratingObject = obj;

    if (iteratingObject.offsetParent) {
        do {
            curleft += iteratingObject.offsetLeft;
            curtop += iteratingObject.offsetTop;
            iteratingObject = iteratingObject.offsetParent;
        } while (iteratingObject);
    }

    return {
        left: curleft,
        top: curtop,
    };
};

const domService = {

    fixAudioLabelContent(content) {
        try {
            const root = xmlDomUtils.getElementFromString(`<div>${content}</div>`);
            const children = xmlDomUtils.getChildElements(root);
            const mediaElement = children.find(element => xmlDomUtils.hasClasses(element, ['ia-audio', 'ia-media']));
            const textElement = children.find(element => xmlDomUtils.hasClass(element, 'Audio'));

            // Move Audio Media element to the front of the text
            // Check is added to avoid errors when alternatives created without attaching audio files
            if (mediaElement && textElement) {
                xmlDomUtils.removeClass(textElement, 'Audio');
                return [
                    '<div>',
                    xmlDomUtils.stringify(mediaElement),
                    xmlDomUtils.stringify(textElement),
                    '</div>',
                ].join('');
            }
            return content;
        } catch (error) {
            window.console.error(error);
            return content;
        }
    },

    getAttributes(node) {
        const a = {};
        const attributes = Array.from(node.attributes);

        for (const attribute of attributes) {
            a[attribute.nodeName] = attribute.textContent;
        }

        return a;
    },

    getParentElementByClass(node, className) {
        let currentNode = Array.isArray(node) && node.length > 0 ? node[0] : node;

        while (currentNode && !domService.hasClass(currentNode, className)) {
            currentNode = currentNode.parentNode;
        }

        return currentNode;
    },

    hasClass(node, className) {
        if (node.classList === undefined) {
            return false;
        }

        return node.classList.contains(className);
    },

    /**
     * Mouse position relative to the element not working on IE7 and below.
     * @param e
     * @returns {{x: number, y: number}}
     */
    getMouseOffsetInsideElement(e) {
        const mousePosDoc = mousePositionDocument(e);
        const target = mouseTarget(e);
        const targetPos = findPos(target);
        const posx = mousePosDoc.x - targetPos.left;
        const posy = mousePosDoc.y - targetPos.top;
        return {
            x: posx,
            y: posy,
        };
    },

    dispatchEvent(element, eventName, data) {
        let event;

        if (window.CustomEvent) {
            event = new CustomEvent(eventName, { detail: data });
        } else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventName, true, true, data);
        }

        element.dispatchEvent(event);
    },

    windowHasParent() {
        return window.parent !== window;
    },

    cleanEmptyspaces(htmlString) {
        if (!htmlString || htmlString === null) {
            return htmlString;
        }
        const parsedHtml = new DOMParser().parseFromString(htmlString, 'text/html');
        parsedHtml.querySelectorAll('[id^="interactionWrapper_"]').forEach((wrapper) => {
            const lastP = wrapper.querySelector('p:last-of-type');

            if (lastP && (lastP.innerHTML.trim() === '&nbsp;' || lastP.innerHTML.trim() === '')) {
                lastP.remove();
            }
        });
        return parsedHtml.documentElement.outerHTML;
    },

    addExtractLabel(htmlString, extract) {
        if (!htmlString) {
            return htmlString;
        }

        const extractLabel = document.createElement('span');
        extractLabel.classList.add('paper-based-extract-label');
        extractLabel.classList.add('new');
        extractLabel.setAttribute('role', 'note');
        extractLabel.setAttribute('aria-label', extract);
        extractLabel.textContent = extract;

        const parsedHtml = new DOMParser().parseFromString(htmlString, 'text/html');
        const container = parsedHtml.body || parsedHtml.documentElement;

        const extractLabelWrapper = container.querySelector('.extract-label-wrapper');
        const parent = container.querySelector('[id^="interactionWrapper_"]');
        if (extractLabelWrapper) {
            extractLabelWrapper.insertAdjacentHTML('afterbegin', extractLabel.outerHTML);
        } else if (parent) {
            parent.insertAdjacentHTML('afterbegin', extractLabel.outerHTML);
        }

        return parsedHtml.documentElement.outerHTML;
    },
};

export default domService;
